import { coverConstants, authConstants } from '../constants';
import { MessagesActions, EventsActions } from './';
import { CoverApi } from '../services';

export class CoverActions {
    static getCover(eventID) {
        return (dispatch) => {
            dispatch({type: coverConstants.GET_COVER_REQUEST});

            CoverApi.getCover(eventID)
                .then((res) => {
                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: coverConstants.GET_COVER_SUCCESS, payload: res.data});
                        return;
                    }

                    return dispatch({type: coverConstants.GET_COVER_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: coverConstants.GET_COVER_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה בטעינת הכיסויים'));
                });
        }
    }

    static uploadCover (eventID, data) {
        return (dispatch) => {
            dispatch({type: coverConstants.UPLOAD_COVER_REQUEST});

            var formData = new FormData();

            for(let key in data) {
                formData.append(key, data[key]);
            }

            CoverApi.uploadCover(eventID, formData)
                .then((res) => {
                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {                        
                        dispatch(EventsActions.getEventData(eventID)); // get updated event data (with new cover)
                        dispatch({type: coverConstants.UPLOAD_COVER_SUCCESS, payload: res.data});
                        // dispatch(MessagesActions.pushSuccess('המסגרת עודכנה בהצלחה!'));
                        return;
                    }

                    dispatch(MessagesActions.pushError('עדכון הכיסוי נכשל אנא נסו שוב...'));
                    return dispatch({type: coverConstants.UPLOAD_COVER_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: coverConstants.UPLOAD_COVER_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה במערכת אנא נסו שוב'));
                });
        }
    }

    static updateCover (eventID, coverID, data) {
        return (dispatch) => {
            dispatch({type: coverConstants.UPDATE_COVER_REQUEST});

            CoverApi.updateCover(eventID, coverID, data)
                .then((res) => {

                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch({type: coverConstants.UPDATE_COVER_SUCCESS, payload: res.data});
                        // dispatch(MessagesActions.pushSuccess('המסגרת עודכנה בהצלחה!'));
                        return;
                    }

                    dispatch(MessagesActions.pushError('לא ניתן לעדכן את הכיסוי אנא נסו שנית'));
                    return dispatch({type: coverConstants.UPDATE_COVER_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: coverConstants.UPDATE_COVER_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה במערכת אנא נסו שוב'));
                });
        }
    }

    static deleteCover (eventID, coverID) {
        return (dispatch) => {
            dispatch({type: coverConstants.DELETE_COVER_REQUEST});

            CoverApi.deleteCover(eventID, coverID)
                .then((res) => {
                    // if user not logged in
                    if(res.status === 403) {
                        dispatch({type: authConstants.USER_LOGGED_OUT});
                    }

                    return res.json();
                })
                .then((res) => {
                    // success
                    if(res.meta.success === true) {
                        dispatch(EventsActions.getEventData(eventID)); // get updated event data (without this cover)
                        dispatch({type: coverConstants.DELETE_COVER_SUCCESS, payload: {eventID: eventID}});
                        // dispatch(MessagesActions.pushSuccess('המסגרת נמחקה בהצלחה!'));
                        return;
                    }

                    dispatch(MessagesActions.pushError('מחיקת הכיסוי נכשלה אנא נסו שוב...'));
                    return dispatch({type: coverConstants.DELETE_COVER_FAILURE});
                })
                .catch((err) => {
                    dispatch({type: coverConstants.DELETE_COVER_FAILURE});
                    dispatch(MessagesActions.pushError('התרחשה תקלה לא צפויה במערכת אנא נסו שוב'));
                });
        }
    }

    static resetCurrentCover () {
        return (dispatch) => {
            dispatch({type: coverConstants.RESET_COVER});
        }
    }
}




// WEBPACK FOOTER //
// ./src/actions/cover.js